<ng-container *ngIf="guides.length">

    <div class="page-sub-description ion-text-left" *ngIf="title">{{ title }}</div>

    <!-- Swiper: mobile always; on desktop too for the "resume" (Continue) sections. -->
    <div class="gs__mobile"
         [class.hide-desktop]="variant !== 'resume'"
         [class.gs__mobile--resume]="variant === 'resume'">
        <swiper-container class="gs__swiper" slides-per-view="auto" space-between="5">
            <swiper-slide
                class="gs__swiper-slide"
                *ngFor="let guide of mobileGuides; trackBy: trackByGuideId">
                <app-guide-card
                    [guide]="guide"
                    [variant]="variant"
                    (guideClick)="guideClick.emit($event)">
                </app-guide-card>
            </swiper-slide>

            <swiper-slide class="gs__swiper-slide" *ngIf="showMobileSeeMore">
                <app-see-more-card [route]="seeMoreRoute"></app-see-more-card>
            </swiper-slide>
        </swiper-container>
    </div>

    <!-- Desktop: grid (not for the resume slider). -->
    <div class="gs__desktop hide-mobile" *ngIf="variant !== 'resume'">
        <div class="gs__grid">
            <app-guide-card
                *ngFor="let guide of desktopGuides; trackBy: trackByGuideId"
                [guide]="guide"
                [variant]="variant"
                (guideClick)="guideClick.emit($event)">
            </app-guide-card>
        </div>

        <ng-container *ngIf="showDesktopSeeMore">
            <div class="gs__divider"></div>
            <a class="gs__more" [routerLink]="seeMoreRoute">
                <img src="/assets/icons/see_more_icon.png" alt="" />
                {{ lang.data['general.see_more'] || 'See more' }}
            </a>
        </ng-container>
    </div>

</ng-container>
